import React from 'react';
import styled from 'styled-components';
import DataTable from 'react-data-table-component';
import { getOrthopedicWardStaff } from '../../UserFunctions';

const Styles = styled.div`
    .overlay {
        position: absolute;
        top: 10px;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: -1;
    }
`;

 
const columns = [
  {
    name: 'Surgeon ID',
    selector: 'id',
    sortable: true,
  },
  {
    name: 'First Name',
    selector: 'first_name',
    sortable: true,
  },
  {
    name: 'Last Name',
    selector: 'last_name',
    sortable: true,
  },
  {
    name: 'Email',
    selector: 'email',
    sortable: true
  },
  {
    name: 'Phone Number',
    selector: 'phone',
    sortable: true,
  },
  {
    name: 'Address',
    selector: 'address',
    sortable: true,
  }
];
 
export class OrthopedicStaff extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            surgeons: [],
            id: '',
            first_name: '',
            last_name: '',
            date_of_birth: '',
            gender: 'M',
            address: '',
            phone_number: '',
        }
        this.updateState = this.updateState.bind(this);
    }

    onChange(e) {
      this.setState({[e.target.name]: e.target.value});
  }

    updateState = state => {
        this.setState({ selectedRows: state.selectedRows });
      }

    componentDidMount() {
        const ward_id = 1;
        getOrthopedicWardStaff(ward_id).then((res, err) => {
            if (res) {
                console.log(res);
                this.setState({surgeons: res})        
            }
            else {
                console.log(err);
            }
        })
    }

  render() {

    return (
      <Styles>
        <DataTable
          title="Orthopedic Ward's Staff"
          columns={columns}
          highlightOnHover
          data={this.state.surgeons}
          selectableRows
          dense
          onSelectedRowsChange={this.updateState}
        />
      </Styles>
    )
  }
};
 
export default OrthopedicStaff
